module.exports = __webpack_public_path__ + "img/ranking.3f43d58a.svg";